import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      home_tagline: "Full‑stack developer crafting performant, elegant interfaces and reliable systems.",
      nav: { home: 'Home', projects: 'Projects', experience: 'Experience', blog: 'Blog', contact: 'Contact' },
      cta_projects: 'View Projects',
      cta_resume: 'Download Resume',
    },
  },
  hi: {
    translation: {
      home_tagline: 'परफ़ॉर्मेंट और सुंदर इंटरफेस बनाने वाला फुल‑स्टैक डेवलपर।',
      nav: { home: 'होम', projects: 'प्रोजेक्ट्स', experience: 'अनुभव', blog: 'ब्लॉग', contact: 'संपर्क' },
      cta_projects: 'प्रोजेक्ट्स देखें',
      cta_resume: 'रेज़्यूमे डाउनलोड करें',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { order: ['querystring', 'localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;


